<template>
  <div class="bg-primary-700 flex min-h-full">
    <aside class="bg-[#252929] w-[90px] md:w-[280px] py-[40px]">
      <div class="pl-[0px] md:pl-[35px]">
        <img
          src="/images/logo_new.svg"
          alt="arcweave"
          class="h-[25px] mb-[50px] hidden md:block"
        />
        <img
          src="/images/logo_new_symbol.svg"
          alt="arcweave"
          class="md:hidden w-[32px] mx-auto mb-[40px]"
        />
      </div>
      <Tabs v-model="selectedTab" orientation="vertical" class="mt-4">
        <TabsList>
          <TabsIndicator variant="highlight" />
          <TabsTrigger
            v-for="item in navigationItemsList"
            :key="item.name"
            :value="item.route"
          >
            <RouterLink
              :to="{ name: item.route }"
              class="flex items-center gap-2 p-3 text-neutral-500 hover:text-neutral-100"
            >
              <component :is="item.icon" class="h-4 w-4" /> {{ item.name }}
            </RouterLink>
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </aside>

    <button
      type="button"
      class="absolute top-[40px] right-[40px] size-5 opacity-50 cursor-pointer hover:opacity-100"
      @click="onCloseAccount"
    >
      <svg-icon :width="'20'" :height="'20'" icon="app-icons/close" />
    </button>

    <main class="flex-1 p-6 md:px-10 md:py-7 overflow-y-auto">
      <router-view :key="$route.path" />
    </main>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { User, Bell } from 'lucide-vue-next';
import { useRoute } from 'vue-router';
import SvgIcon from '@ui/components/SvgIcon.vue';
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsIndicator,
} from '@ui/components/tabs';

const navigationItems = [
  {
    name: 'Profile',
    icon: User,
    route: 'accountProfile',
  },
  {
    name: 'Notifications',
    icon: Bell,
    route: 'accountNotifications',
  },
];

export default {
  components: {
    SvgIcon,
    Tabs,
    TabsList,
    TabsTrigger,
    TabsIndicator,
  },

  beforeRouteEnter(_to, from, next) {
    next(vm => {
      vm.previousRoute = from;
    });
  },

  setup() {
    const previousRoute = ref(null);
    const navigationItemsList = ref(navigationItems);

    const route = useRoute();

    const selectedTab = computed({
      get() {
        return route.matched[1].name;
      },
      set() {},
    });

    return {
      navigationItemsList,
      previousRoute,
      selectedTab,
    };
  },

  methods: {
    onCloseAccount() {
      this.$router.push(this.previousRoute.path);
    },
  },
};
</script>
